import type React from "react";
import { BadgeProps } from "../../interface/badge.interface";



const Badge: React.FC<BadgeProps> = ({mobile,text="new"}) => {
  return <span className={`badge absolute px-2 animate-float rounded-2xl bg-[#ffd700] text-midnight_text text-[8px] ${mobile? 'left-0 -translate-1/2 -z-10 -rotate-45':'top-0 left-0 -translate-1/2 -z-10 -rotate-45'}`}>{text}</span>;
}


export default Badge;